<template>
  <mdb-modal :show="show" @close="close()" size="lg">
    <mdb-modal-header class="aqua-gradient">
      <mdb-modal-title>Select order</mdb-modal-title>
    </mdb-modal-header>
    <mdb-modal-body class="overflow-hidden d-flex">
      <mdb-container>
        <mdb-row>
          <mdb-col
            v-for="(order, index) in orders"
            :key="`order-${index}`"
            col="3"
          >
            <order-order
              simple
              :order="order"
              @selected="close(order.info.uuid)"
            />
          </mdb-col>
          <div class="text-center w-100">
            <h4 v-if="orders.length === 0">Unfortunately, no suitable orders found.</h4>
          </div>
        </mdb-row>
      </mdb-container>
    </mdb-modal-body>
  </mdb-modal>
</template>

<script>
import {
  mdbContainer,
  mdbModal,
  mdbModalHeader,
  mdbModalTitle,
  mdbModalBody,
  mdbRow,
  mdbCol
} from 'mdbvue'
import { mapActions } from 'vuex'
import OrderOrder from './OrderOrder'
import {errorCatch} from '../utils'

export default {
  name: 'OrderSelectModal',
  data () {
    return {
      orders: [],
      show: false,
      callback: uuid => { console.log('Selected order with uuid: ', uuid) }
    }
  },
  methods: {
    ...mapActions(['apiOrdersGetSimple']),
    close (uuid = null) {
      this.orders = []
      this.show = false
      if (uuid) {
        this.callback(uuid)
      }
      this.callback = uuid => { console.log('Selected order with uuid: ', uuid) }
    }
  },
  mounted () {
    this.$bus.$on('modal-order-select', data => {
      this.callback = data.callback
      const current = data.current
      const agent = data.agent || null
      const client = data.client || null
      this.apiOrdersGetSimple({agent, client, current})
        .then(orders => {
          this.orders = orders
          this.show = true
        })
        .catch(errorCatch('Orders Get Simple failed', this))
    })
  },
  beforeDestroy () {
    this.$bus.$off('modal-order-select')
  },
  components: {
    mdbContainer,
    mdbModal,
    mdbModalHeader,
    mdbModalTitle,
    mdbModalBody,
    OrderOrder,
    mdbCol,
    mdbRow
  }
}
</script>

<style lang="sass">
.modal-body
  max-height: 50vh
</style>



// WEBPACK FOOTER //
// src/components/OrderSelectModal.vue